<template>
	<div :id="id" class="position-relative filter-container">
		<div v-if="typeFilter.value === 'list'" class="selectAll">
			<button class="selectAll_btn" type="button" @click="onSelectAll">
				<svg-sprite width="18" height="18" icon-id="ok"></svg-sprite>
				<span>Select all</span>
			</button>
		</div>
		<div v-if="typeFilter.value === 'date' && typeFilter.options === 'empty'" class="filter_head">
			<v-checkbox
					class="checkboxEmpty"
					@change="onChangeEmpty"
					:label="`Empty`"
					dense
					hide-details
					v-model="statusEmpty"
			></v-checkbox>

		</div>
		<div class="filter_body" :class="{'pad_20': typeFilter.value !== 'options'}">
			<v-date-picker
					v-if="typeFilter.value === 'date'"
					class="picker-table dataPickerFilter"
					width="300"
					color="green"
					:disabled="isDisabled"
					v-model="dates"
					@input="onChange"
					prev-icon="mdi-menu-left"
					next-icon="mdi-menu-right"
					isNoTitle
					range
					no-title
			></v-date-picker>
			<div
					v-else-if="typeFilter.value === 'number'"
					class="numberWR"
			>
				<type-number
						:condition="isRefresh"
						:filterName="modelFilter"
						@updateNumber="onChangeNumber"
				></type-number>
			</div>
			<div v-else-if="typeFilter.value === 'options'">
				<div class="options">
					<div class="options_head">
						<div class="options_head-text">
							<span>On</span>
							<span>All</span>
							<span>Off</span>
						</div>
					</div>
					<div class="options_body">
						<radio-group
								title="Annual inspection"
								:radioKey="{ id: 'alignment', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_alignment')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="Alignment"
								:radioKey="{ id: 'inspection', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_inspection')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="PM service"
								:radioKey="{ id: 'pm', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_pm')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="Towing"
								:radioKey="{ id: 'towing', w: 20, h: 20 }"
								@updateRadio="onRadio($event, 'filter_option_towing')"
								:isRefresh="isRefresh"
						></radio-group>
					</div>
				</div>
			</div>
			<v-autocomplete
					v-else
					class="green-icon pt-5 mt-0"
					v-model="select"
					:items="items"
					:label="label"
					item-text="value"
					item-value="id"
					color="green"
					:menu-props="{contentClass: 'filter-dd', maxWidth: 300, minWidth: 300, nudgeWidth: 300}"
					@input="changeFilter($event)"
					multiple
					clearable
					small-chips
					deletable-chips
					chips
			></v-autocomplete>
		</div>
	</div>
</template>
<script>
import { mapActions } from "vuex";
// components
import TypeNumber from "@/shared/table/filter-table/TypeNumber/TypeNumber";
import RadioGroup
from "@/components/Maintenance/Customer/CustomerForm/SixthTab/FilterTable/RadioGroup/RadioGroup";

export default {
	name: "FilterTable",
	components: {
		TypeNumber,
		RadioGroup
	},
	props: {
		isRefresh: String,
		filterStatus: Array,
		isDisabled: Boolean,
		dataFilter: {
			type: Array
		},
		modelFilter: {
			type: String,
			default: ''
		},
		filterUpdate: {
			type: Boolean
		},
		labelFilter: {
			type: String
		},
		typeFilter: {
			type: Object,
			default: null
		},
		uniqId: Object,
		refreshDate: String
	},
	computed: {
		items() {
			return this.dataFilter || [].filter((value) => value != null && value);
		},
		id() {
			return "dd" + (Math.round(Math.random() * (1000 - 20)) + 10);
		},
		update() {
			return this.filterUpdate;
		},
		label() {
			switch (this.modelFilter) {
				case 'filter_status':
					return "Select status";
				case 'filter_technician':
					return "Select fleet manager";
				case 'filter_unit':
					return 'Select unit';
				case 'filter_arrived':
					return 'Arrived';
				case 'filter_unit_type':
					return 'Select unit type';
				case 'filter_wo_type':
					return 'Select WO type';
				case 'filter_id':
					return 'Select id';
				case 'filter_request_date':
					return 'Select request date';
				default:
					return 'Select date';
			}
		}
	},
	watch: {
		isRefresh(val, oldVal) {
			if (val !== oldVal) {
				if (this.modelFilter === 'filter_status') {
					this.select = this.filterStatus.filter(item => item.id !== 9);
				} else {
					this.select = [];
				}

				this.statusReviewed = false;
				this.statusEmpty = false;
				this.dates = [ new Date().toISOString().substr(0, 10) ];
			}
		},
		uniqId(val, oldVal) {
			const model = this.typeFilter.value;
			const { id, key } = val;
			const { id: oldId } = oldVal;
			if (id !== oldId && this.modelFilter === key) {
				this.select = this.items.map(item => item.id);
				this.$emit("change-sort", { key: this.modelFilter, value: this.select, model });
			}
		},
		filterUpdate(val) {
			if (val) {
				//this.select = []
				this.$emit('create-refresh', this.modelFilter);
			}
		},
		refreshDate(val, oldVal) {
			if (val !== oldVal) {
				this.select = [];
				this.dates = new Date().toISOString().substr(0, 10);
			}
		}
	},
	data() {
		return {
			select: [],
			dates: [ new Date().toISOString().substr(0, 10) ],
			row: -1,
			statusReviewed: false,
			statusEmpty: false
		};
	},
	methods: {
		...mapActions([ 'safetyCalendar' ]),
		onRadio(value, key) {
			const model = this.typeFilter.value;
			this.$emit("change-sort", { key, value, model });
		},
		onChangeNumber(values) {
			const model = this.typeFilter.value;
			const key = this.modelFilter;
			const value = { type: values.type, value: values.value };
			this.$emit("change-sort", { key, value, model });
		},
		changeFilter(value) {
			const model = this.typeFilter.value;
			const key = this.modelFilter;

			this.$emit("change-sort", { key, value, model });
		},
		onChange() {
			const model = this.typeFilter.value;
			const key = this.modelFilter;
			const [ from, to = from ] = this.dates;
			const value = { from, to };
			this.$emit("change-sort", { key, value, model });
		},
		onSelectAll() {
			this.$emit('updateFilterListAll');
		},
		onChangeEmpty() {
			const model = 'checkbox';
			const key = `${ this.modelFilter }_empty`;
			this.$emit("change-sort", { key, value: this.statusEmpty, model });
		}
	},
	mounted() {
		this.$emit('filter-created', this.modelFilter);
		if (this.modelFilter === 'filter_status') this.select = this.filterStatus.filter(item => item.id !== 9);
	}
};
</script>
